import createActionConstants from 'lib/create-action-constants'

export const constants = createActionConstants('ui', [
  'SET_MODE',
  'SET_RESET_PASSWORD_TOKEN',
  'TOGGLE_PRIVACY_AGREED',
  'SET_FIELD',

  'SUBMIT',
  'SUBMIT_SUCCESS',
  'SUBMIT_FAILURE'
])

export const setMode = mode => ({
  type: constants.SET_MODE,
  payload: mode
})

export const togglePrivacyAgreed = () => ({
  type: constants.TOGGLE_PRIVACY_AGREED
})

export const setField = (field, value, error) => ({
  type: constants.SET_FIELD,
  payload: {
    field, value
  },
  error
})

export const submit = (mode, fields, history) => ({
  type: constants.SUBMIT,
  payload: {
    mode, fields, history
  }
})
